export default "__VITE_ASSET__CgMrjv94__"